 <!--Main COintainer Starts-->
<div class="height-100pe" [@routerTransition]>
  <!--User Profile wizard Starts
    *ngIf="ShowpatientDeatils"
      -->
  <div class="row margin-top-16px height-100pe">
    <div class=" col-xl-12 col-lg-12 col-md-12 col-sm-12">

      <div class=" nurse-profile-card-body height-100pe padding-bottom-0px">
        <div class="row height-100pe">
          <!--<div class="col-md-2 padding-right-0px color-col-md-2 padding-top-5">-->
          <div class="col-md-2 height-100pe padding-right-0px">
            <div class="card height-100pe border-right3px-solidgray">
              <div class="card-body padding-all-0px margin-left-0px">
                <div class="row margin-top-auto margin-bottom-auto">
                  <a class="nav-link-hand margin-left-29px padding-top-5px padding-bottom-5px" title="Back To Profile" (click)="BackToProfile()"><i class="fas fa-angle-double-left font-size-16px nav-link-hand color-backarrow"></i> </a>
                </div>
                <!--<div class="row">
                  <a class="nav-link-hand margin-left-29px margin-top-12p" title="Partner" (click)="flip()"><i class="fas fa-angle-double-left font-size-16px nav-link-hand"></i> Back</a>
                </div>-->

                <div class="padding-left-14px padding-right-14px padding-bottom-14px">
                  <!--<div class="card background-pay border-card2">

                    <div class="row display-inline margin-top-10" *ngIf="SelectedPatient">
                      <div class="offset-md-3 col-md-9 padding-left-0px">
                        <img class="img-circle-50" [src]='SelectedPatient.PatientImageFile' onError="this.src='dummy.jpg';">
                      </div>
                    </div>
                    <div class="row margin-left-zero">
                      <div class="offset-md-3 col-md-7 padding-left-0px">

                        <label class="font-size-16px" *ngIf="titleapp!=='App'">{{DisplayName}}</label>
                        <label class="font-size-16px" *ngIf="titleapp == 'App' || titleapp == 'cycle' ">{{Displaynameapp}}</label>
                      </div>
                    </div>

                    <div class="row margin-left-zero text-align-center">
                      <div class="offset-md-1 col-md-9 padding-left-0px">
                        <label class="font-size-16px" *ngIf="titleapp!=='App'">{{FormattedCode}}</label>
                        <label class="font-size-16px" *ngIf="titleapp == 'App' || titleapp == 'cycle' ">{{FormattedCodeapp}}</label>
                      </div>

                    </div>
                    <div class="row margin-left-zero text-align-center margin-right-0px" *ngIf="SelectedPatient">
                      <div class="offset-md-3 col-md-6 padding-left-0px padding-right-0px">
                        <label class="font-size-16px">{{SelectedPatient.Telephone1}}</label>
                      </div>

                    </div>
                  </div>-->


                  <div class=" card  height-100pe profile-card-border">
                    <div class="card-body padding-left-0px padding-right-0px padding-top-0px padding-bottom-0px margin-left-0px">


                      <div class="">
                        <div class="row">
                          <div [ngSwitch]="SelectedPatient.RegistrationReason" class="col-md-4 text-align-center padding-top-0px padding-left-0px padding-right-0px">
                            <a data-toggle="tooltip" data-placement="bottom" title="SURGT">
                              <img *ngSwitchCase="'SURGT'" class="img-circle-40" src="Surrogate.png">
                            </a>
                            <a data-toggle="tooltip" data-placement="bottom" title="EGG">
                              <img *ngSwitchCase="'EGG'" class="img-circle-40" src="Egg.png">
                            </a>
                            <a data-toggle="tooltip" data-placement="bottom" title="SEMEN">
                              <img *ngSwitchCase="'SEMEN'" class="img-circle-40" src="Semen.png">
                            </a>
                          </div>
                        </div>
                        <div class="row" *ngIf="SelectedPatient">
                          <div class="col-md-12 text-align-center padding-top-5px padding-left-0px padding-right-0px">
                            <img class="img-circle-50" [src]='SelectedPatient.PatientImageFile' onError="this.src='dummy.jpg';">
                          </div>
                        </div>
                        <div class="row margin-left-3px margin-right-0px padding-top-5px">
                          <div class="col-md-12">
                            <h4 class="margin-bottom-0px  font-size-20px margin-left-3px font-weight-bold text-align-center" *ngIf="titleapp!=='App'">{{DisplayName}}</h4>
                            <h4 class="margin-bottom-0px  font-size-20px margin-left-3px font-weight-bold text-align-center" *ngIf="titleapp == 'App' || titleapp == 'cycle' ">{{Displaynameapp}}</h4>
                          </div>

                        </div>
                        <div class="row margin-left-3px margin-right-0px padding-bottom-10px">
                          <div class="col-md-12">
                            <h4 class="margin-bottom-0px color-#999999 font-size-12px margin-left-3px font-weight-normal text-align-center" *ngIf="titleapp!=='App'">{{FormattedCode}}</h4>
                            <h4 class="margin-bottom-0px color-#999999 font-size-12px margin-left-3px font-weight-normal text-align-center" *ngIf="titleapp == 'App' || titleapp == 'cycle' ">{{FormattedCodeapp}}</h4>
                          </div>

                        </div>

                      </div>

                      <div class="background-color-wt" *ngIf="SelectedPatient">

                        <div class="row margin-left-3px margin-right-0px padding-top-15px">
                          <div class="col-md-4 padding-left-0px padding-right-0px">
                            <h4 class="margin-bottom-0px  font-size-12px margin-left-3px font-weight-bold text-align-center">{{SelectedPatient.Age}}</h4>
                          </div>
                          <div class="col-md-4 padding-left-0px padding-right-0px">
                            <h4 class="margin-bottom-0px  font-size-12px margin-left-3px font-weight-bold text-align-center">{{SelectedPatient.Gender}}</h4>
                          </div>
                          <div class="col-md-4 padding-left-0px padding-right-0px">
                            <h4 class="margin-bottom-0px  font-size-12px margin-left-3px font-weight-bold text-align-center">{{SelectedPatient.PatientCategory}}</h4>
                          </div>
                        </div>
                        <div class="row margin-left-3px margin-right-0px padding-bottom-15px">
                          <div class="col-md-4 padding-left-0px padding-right-0px">
                            <h4 class="margin-bottom-0px  font-size-10px margin-left-3px font-weight-normal text-align-center">Age</h4>
                          </div>
                          <div class="col-md-4 padding-left-0px padding-right-0px">
                            <h4 class="margin-bottom-0px  font-size-10px margin-left-3px font-weight-normal text-align-center">Sex</h4>
                          </div>
                          <div class="col-md-4 padding-left-0px padding-right-0px">
                            <h4 class="margin-bottom-0px  font-size-10px margin-left-3px font-weight-normal text-align-center">Category</h4>
                          </div>
                        </div>
                        
                      </div>
                    </div>

                  </div>


                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-md-12 padding-left-3px padding-right-0px">


                    <!--<ul id="nav-tabs-wrapper" class="nav nav-tabs nav-pills nav-stacked well width-211px display-inherit border-bottom-0px">
                      <li class="nav-link4 border-top-light border-bottom-light padding-top-3px padding-bottom-3px active"><a class="link2 margin-left-17px active" href="#vtab1" data-toggle="tab">Profile<i class="fas fa-caret-right icon-caret-right float-right margin-top-3px"></i></a></li>
                      <li class="nav-link4 border-bottom-light padding-top-3px padding-bottom-3px"><a class="link2 margin-left-17px" href="#vtab2" data-toggle="tab">Messages<i class="fas fa-caret-right icon-caret-right float-right margin-top-3px"></i></a></li>

                    </ul>-->
                    <nav>
                      <div class="chatsd product-chart-wrapper product-chat-width-cyclestab2 agreement-chart-wrapper ps overflow-x-hidden padding-lrt " data-ps-id="dfsfsde">
                        <div class="nav nav-tabs display-inherit border-bottom-0px">

                          <a class="nav-item nav-link link3 margin-left-17px  active border-top-light border-bottom-light" role="tab"
                             data-toggle="pill" href="#ApplicantInfo">
                            Profile<i class="fas fa-caret-right icon-caret-right float-right margin-top-3px"></i>
                          </a>
                          <a class="nav-item nav-link link3 margin-left-17px  border-bottom-light" role="tab"
                             data-toggle="pill" href="#profileinfo">Message<i class="fas fa-caret-right icon-caret-right float-right margin-top-3px"></i></a>
                          <a class="nav-item nav-link link3 margin-left-17px  border-bottom-light" role="tab"
                             data-toggle="pill" href="#documentinfo">Documents<i class="fas fa-caret-right icon-caret-right float-right margin-top-3px"></i></a>
                          <a class="nav-item nav-link link3 margin-left-17px  border-bottom-light" role="tab"
                             data-toggle="pill" href="#observationsinfo">Observations<i class="fas fa-caret-right icon-caret-right float-right margin-top-3px"></i></a>
                          <a class="nav-item nav-link link3 margin-left-17px  border-bottom-light" role="tab"
                             data-toggle="pill" href="#Orders">Orders<i class="fas fa-caret-right icon-caret-right float-right margin-top-3px"></i></a>
                          <a class="nav-item nav-link link3 margin-left-17px  border-bottom-light" role="tab"
                             data-toggle="pill" href="#Prescription">Prescriptions<i class="fas fa-caret-right icon-caret-right float-right margin-top-3px"></i></a>
                          <a class="nav-item nav-link link3 margin-left-17px  border-bottom-light" role="tab"
                             data-toggle="pill" href="#healthrecordinfo">Health Records<i class="fas fa-caret-right icon-caret-right float-right margin-top-3px"></i></a>
                          <a class="nav-item nav-link link3 margin-left-17px  border-bottom-light" role="tab"
                             data-toggle="pill" href="#visitview">Visits<i class="fas fa-caret-right icon-caret-right float-right margin-top-3px"></i></a>
                          <a class="nav-item nav-link link3 margin-left-17px  border-bottom-light" role="tab"
                             data-toggle="pill" href="#billprofile">Bills<i class="fas fa-caret-right icon-caret-right float-right margin-top-3px"></i></a>
                          <a class="nav-item nav-link link3 margin-left-17px  border-bottom-light" role="tab"
                             data-toggle="pill" href="#servicelist">Services<i class="fas fa-caret-right icon-caret-right float-right margin-top-3px"></i></a>
                          <a class="nav-item nav-link link3 margin-left-17px  border-bottom-light" role="tab"
                             data-toggle="pill" href="#Cycles">Cycles<i class="fas fa-caret-right icon-caret-right float-right margin-top-3px"></i></a>
                        </div>
                      </div>
                    </nav>


                  </div>
                </div>
              </div>
            </div>

          </div>
          <!--</div>-->
          <div class="col-md-10 padding-left-0px padding-right-0px primary-background">
            <div class="tab-content">


              <div class="tab-pane container active margin0px-max-width-100" id="ApplicantInfo" role="tabpanel">

                <div class="margin-left-0px" id="advanced-form" action="#">
                  <!--<h3><span class="s-title"><span class="xs-hide">Personal Info</span> <span class="s-icon"><i class="fas fa-caret-up top-arrow"></i></span><span class="t-icon"><i class="fas fa-check-circle"></i></span></span></h3>
      <fieldset class="margin-top-10">
        <div>
          <legend>Personal Info</legend>



        </div>
      </fieldset>-->
                  <!--<div class="img-one">
        <img src="../../../../../../../wwwroot/healins-assets/images/admin/profile-pic.jpg" class="img-circle" />
        <label>
          Lily Thomas
        </label>

        <label>JOB1</label>
      </div>-->
                  <!--<div class="">
        <img src="../../../../../../../wwwroot/healins-assets/images/admin/profile-pic.jpg" class="img-width" />
        <label>Lilly Thoms</label>
        <label>JOb1</label>
      </div>-->
                  <!-- step-1 -->
                  <!--<h3><span class="s-title"><span class="xs-hide">Personal Info</span> <span class="s-icon"><i class="fas fa-caret-up top-arrow"></i></span><span class="t-icon"><i class="fas fa-check-circle"></i></span></span></h3>-->
                  <fieldset class="margin-top-10 padding-top-0px margin-left-0px padding-left-0px">
                    <div *ngIf="SelectedPatient" class="margin-left-0px">
                      <!--<legend>Personal Info</legend>-->

                      <personaldetailview [FormattedCode]="SelectedPatient.FormattedCode" [ActorCode]="SelectedPatient.ActorCode"></personaldetailview>

                    </div>
                  </fieldset>
                  <!--<h3><span class="s-title"><span class="xs-hide">Guardian</span> <span class="s-icon"><i class="fas fa-caret-up top-arrow"></i></span><span class="t-icon"><i class="fas fa-check-circle"></i></span></span></h3>
      <fieldset class="margin-top-10">
        <div *ngIf="SelectedPatient">
          <legend>Guardian</legend>

          <guardianinfoview [ActorCode]="SelectedPatient.ActorCode"></guardianinfoview>

        </div>
      </fieldset>-->
                  <!-- Step2 -->
                  <!--<h3 ><span class="s-title"><span class="xs-hide">Vital Signs</span> <span class="s-icon"><i class="fas fa-caret-up"></i></span><span class="t-icon"><i class="fas fa-check-circle"></i></span></span></h3>
      <fieldset class="margin-top-10 padding-top-0px" hidden>
        <div *ngIf="SelectedPatient">
          <legend>Vital Signs</legend>
          <vitals [FormattedCode]="SelectedPatient.FormattedCode"></vitals>

        </div>
      </fieldset>-->
                  <!--<h3 hidden><span class="s-title"><span class="xs-hide">Helath Records</span> <span class="s-icon"><i class="fas fa-caret-up"></i></span><span class="t-icon"><i class="fas fa-check-circle"></i></span></span></h3>
      <fieldset class="margin-top-10" hidden>
        <div *ngIf="SelectedPatient">
          <legend>Health Records</legend>

          <viewedittext [FormattedCode]="SelectedPatient.FormattedCode"></viewedittext>


        </div>
      </fieldset>-->
                  <!--<h3 hidden><span class="s-title"><span class="xs-hide">Emergency</span> <span class="s-icon"><i class="fas fa-caret-up"></i></span><span class="t-icon"><i class="fas fa-check-circle"></i></span></span></h3>
      <fieldset class="margin-top-10" hidden>
        <div *ngIf="SelectedPatient">
          <legend>Emergency</legend>
          <emergencyinfoview [ActorCode]="SelectedPatient.ActorCode"></emergencyinfoview>

        </div>
      </fieldset>-->
                  <!--<h3 hidden><span class="s-title"><span class="xs-hide">Referral</span> <span class="s-icon"><i class="fas fa-caret-up top-arrow"></i></span><span class="t-icon"><i class="fas fa-check-circle"></i></span></span></h3>
      <fieldset class="margin-top-10 padding-top-0px" hidden>
        <div *ngIf="SelectedPatient">
          <legend>Referral</legend>

          <referralview [ActorCode]="SelectedPatient.ActorCode"></referralview>

        </div>
      </fieldset>-->
                  <!-- Step3 -->
                  <!--<h3><span class="s-title"><span class="xs-hide">Documents</span> <span class="s-icon"><i class="fas fa-caret-up"></i></span><span class="t-icon"><i class="fas fa-check-circle"></i></span></span></h3>
      <fieldset class="margin-top-10">
        <div *ngIf="SelectedPatient">
          <legend>Documents</legend>
          <otherdatainfo [ActorCode]="SelectedPatient.ActorCode"></otherdatainfo>

        </div>
      </fieldset>-->
                  <!-- Step4 -->
                  <!-- Step5 -->
                  <!--<h3><span class="s-title"><span class="xs-hide">Observations</span> <span class="s-icon"><i class="fas fa-caret-up"></i></span><span class="t-icon"><i class="fas fa-check-circle"></i></span></span></h3>
      <fieldset class="margin-top-10">
        <div>
          <legend>Observations</legend>
          <observationsinfov2view></observationsinfov2view>


        </div>
      </fieldset>-->
                </div>
              </div>
              <div class="tab-pane container margin-left-0px margin-right-0px padding-left-0px margin-top-10" id="profileinfo" role="tabpanel">
                <div class="row">
                  <div class="col-md-7">

                    <div class="card">
                      <div class="row">

                        <div class="col-md-12">
                          <div class="card">
                            <div class="card-header wh-header border-bottom1px-solidgray border-left15px-solidgray font-weight-normal padding-top-6px padding-bottom-6px padding-left-5px">
                              <label class="margin-bottom-0px color-backarrow font-size-25px font-weight-bold">Messages</label>
                              
                            </div>
                            <div class="card-body padding-top-0px padding-right-0px">

                              <div class="chatsd product-chart-wrapper agreement-chart-wrapper ps ps2 padding-lrt height-500px" data-ps-id="dfsfsde">
                                <div *ngFor="let l of CurrentCustomerMessageController">
                                  <div class="row margin-bottom-10px margin-top-10" *ngIf="l.Who2Who=='FromProvider'">
                                    <div class="offset-md-6 col-md-5 text-align-right border-right-sender">


                                      <div class="row">
                                        <div class="col-md-12 padding-left-11px">
                                          <label class="font-size-12px margin-bottom-0px date-color-contracts">{{l.CreatedTimeStamp|date:'dd MMM'}}</label>
                                          <div>
                                            <label class="margin-bottom-0px margin-left-5px font-size-12px color-secondary  padding-left-0px">{{l.Purpose}}</label>
                                          </div>
                                        </div>
                                        <!--<div class="col-md-8 text-align-right">

                            </div>-->
                                      </div>


                                      <div class="message-sender">

                                        <div class="row">
                                          <div class="col-md-12 margin-top-4px  font-size-13px text-align-justify">
                                            {{l.MessageText}}


                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="row margin-bottom-10px margin-top-10" *ngIf="l.Who2Who=='FromPatient'">
                                    <!--*ngIf="l.Who2Who=='FromPatient'"-->
                                    <div class="offset-md-1 col-md-8 border-left-recevier">
                                      <div class="row">
                                        <div class="col-md-12 padding-left-11px">
                                          <label class="font-size-12px margin-bottom-0px date-color-contracts">{{l.CreatedTimeStamp|date:'dd MMM'}}</label>
                                          <div>
                                            <label class="margin-bottom-0px margin-left-5px font-size-12px color-secondary  padding-left-0px">{{l.Purpose}}</label>
                                          </div>
                                        </div>
                                        <!--<div class="col-md-8 text-align-right">

                            </div>-->
                                      </div>
                                      <div class="receiver">
                                        <!--<div class="row">
                              <div class="col-md-12">
                                <div class="row">
                                  <div class="col-md-6 padding-left-11px">
                                    <label class="margin-bottom-0px margin-left-5px font-size-13px color-secondary  padding-left-0px">{{l.Purpose}}</label>
                                  </div>
                                  <div class="col-md-6 text-align-right">
                                    <label class="font-size-13px margin-bottom-0px date-color-contracts">{{l.CreatedTimeStamp|date:'dd MMM'}}</label>
                                  </div>
                                </div>
                              </div>
                            </div>-->

                                        <div class="row">
                                          <div class="col-md-12 margin-top-4px  font-size-13px text-align-justify">
                                            {{l.MessageText}}

                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                      </div>


                    </div>





                  </div>
                  <div class="col-md-5 padding-left-0px">
                    <div class="card affix my-profile-form">
                      <div class="card-header wh-header border-bottom1px-solidgray border-left15px-solidgray font-weight-normal padding-top-6px padding-bottom-6px padding-left-5px">
                        <div class="row">


                          <div class="col-md-8">

                            <label class="margin-bottom-0px color-backarrow font-size-25px">Message To Patient</label>
                            
                          </div>
                          <div class="col-md-4">
                            <a class="nav-link-hand education-navlink float-right">
                              <span class="badge"><i class="fas fa-pencil-alt"></i></span>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div class="card-body margin-left-zero padding-left-0px padding-right-0px">
                        <form class="form " novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">
                          <div class="row margin-bottom-10px margin-left-auto">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-4 text-align-right margin-tg-auto">
                                  <label for="diaplayName" class="font-size-12px margin-bottom-0px"> Purpose</label>
                                </div>


                                <div class="col-md-6">
                                  <CodeTypeValue CodeType="PRPS" id="CurrentSaveCustomerMessageRequest.Purpose"
                                                 [(ngModel)]="CurrentSaveCustomerMessageRequest.Purpose" SelectedValue=""
                                                 name="CurrentSaveCustomerMessageRequest.Purpose"></CodeTypeValue>
                                  <!--id="CurrentActorPersonalDetailInfoRequest.MaritalStatus"
                      [(ngModel)]="CurrentActorPersonalDetailInfoRequest.MaritalStatus" SelectedValue="{{CurrentActorPersonalDetailInfoRequest.MaritalStatus}}"
                      name="CurrentActorPersonalDetailInfoRequest.MaritalStatus"-->

                                </div>
                              </div>


                            </div>

                          </div>

                          <div class="row margin-left-auto margin-bottom-10px">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-4 text-align-right">
                                  <label for="diaplayName" class="font-size-12px margin-bottom-0px">Message</label>
                                </div>

                                <div class="col-md-6">
                                  <textarea class="form-control3 size-2 width-remarks-206px" rows="2" placeholder="Message" name="CurrentSaveCustomerMessageRequest.MessageText"
                                            [(ngModel)]="CurrentSaveCustomerMessageRequest.MessageText" minlength="1" maxlength="200"
                                            #addconcerns_text="ngModel"></textarea>

                                </div>
                              </div>


                            </div>
                          </div>
                          <div class="row">
                            <button *ngIf='!isRequesting' class="btn button-Schedule actions-btn-prime nav-link-hand cancel-two margin-left-0px margin-right-5px margin-left-auto">Cancel</button>
                            <button type="submit" class="btn font-size-13px actions-btn-prime  margin-right-auto">Send</button>
                          </div>
                        </form>
                      </div>

                    </div>
                  </div>
                </div>

              </div>
              <div class="tab-pane container margin-left-0px margin-right-0px" id="documentinfo" role="tabpanel">

                <div *ngIf="SelectedPatient">
                  <otherdatainfo [ActorCode]="SelectedPatient.ActorCode"></otherdatainfo>

                </div>
              </div>
              <div class="tab-pane container margin-left-0px margin-right-0px padding-left-0px" id="observationsinfo" role="tabpanel">

                <div *ngIf="SelectedPatient">
                  <patinettestview [ActorCode]="SelectedPatient.ActorCode" [FormattedCode]="SelectedPatient.FormattedCode" [PatientCode]="SelectedPatient.PatientRegistrationNumber"></patinettestview>

                </div>
              </div>
              <div class="tab-pane container margin-left-0px margin-right-0px padding-right-0px" id="Orders" role="tabpanel">

                <div *ngIf="SelectedPatient">
                  <ordersprofile [ActorCode]="SelectedPatient.ActorCode" [FormattedCode]="SelectedPatient.FormattedCode" [PatientCode]="SelectedPatient.PatientRegistrationNumber"></ordersprofile>

                </div>
              </div>
              <div class="tab-pane container margin-left-0px margin-right-0px" id="Prescription" role="tabpanel">

                <div *ngIf="SelectedPatient">
                  <prescriptionview [ActorCode]="SelectedPatient.ActorCode" [FormattedCode]="SelectedPatient.FormattedCode" [PatientCode]="SelectedPatient.PatientRegistrationNumber"></prescriptionview>

                </div>
              </div>
              <div class="tab-pane container margin-left-0px margin-right-0px" id="healthrecordinfo" role="tabpanel">

                <div *ngIf="SelectedPatient">
                  <viewedittext [ActorCode]="SelectedPatient.ActorCode" [FormattedCode]="SelectedPatient.FormattedCode" [PatientCode]="SelectedPatient.PatientRegistrationNumber"></viewedittext>

                  <!--<visitview [ActorCode]="SelectedPatient.ActorCode" [FormattedCode]="SelectedPatient.FormattedCode" [PatientCode]="SelectedPatient.PatientRegistrationNumber"></visitview>-->

                </div>
              </div>
              <div class="tab-pane container margin-left-0px margin-right-0px" id="visitview" role="tabpanel">

                <div *ngIf="SelectedPatient">
                  <!--<medicalrecordview [ActorCode]="SelectedPatient.ActorCode"
      [FormattedCode]="SelectedPatient.FormattedCode"
      ></medicalrecordview>-->
                  <visitview [ActorCode]="SelectedPatient.ActorCode" [FormattedCode]="SelectedPatient.FormattedCode" [PatientCode]="SelectedPatient.PatientRegistrationNumber"></visitview>

                </div>
              </div>
              <div class="tab-pane container margin-right-0px margin-left-0px" id="billprofile" role="tabpanel">

                <div *ngIf="SelectedPatient">
                  <billprofile [ActorCode]="SelectedPatient.ActorCode" [FormattedCode]="SelectedPatient.FormattedCode"></billprofile>

                </div>
              </div>
              <div class="tab-pane container margin-left-0px margin-right-0px padding-right-0px" id="servicelist" role="tabpanel">

                <div *ngIf="SelectedPatient">
                  <servicesview [ActorCode]="SelectedPatient.ActorCode" [FormattedCode]="SelectedPatient.FormattedCode" [PatientCode]="SelectedPatient.PatientRegistrationNumber"></servicesview>

                </div>
              </div>
              <div class="tab-pane container margin-left-0px margin-right-0px padding-right-0px" id="Cycles" role="tabpanel">

                <div *ngIf="SelectedPatient">
                  <cyclesprofile [ActorCode]="SelectedPatient.ActorCode" [FormattedCode]="SelectedPatient.FormattedCode" [PatientCode]="SelectedPatient.PatientRegistrationNumber"></cyclesprofile>

                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
  <!--User Profile wizardEnd-->
</div>
<!--<providerdashboard *ngIf="showdashboard" hidden></providerdashboard>-->
<!--Main COintainer ends-->
<!--<div *ngIf="IsSetAccessRights">-->
<!--<div *ngIf="0 == 1">

  <section id="user-profile">
    <div class="row">
      <div class="col-12">
        <div class="card profile-with-cover">
          <div class="media profil-cover-details row">
            <div class="col-6">
              <div class="align-self-start halfway-fab pl-3 pt-2">
                <div class="text-left">
                  <h3 class="card-title pink mb-4">{{CurrentActorProfileController.DisplayName}}</h3>
                </div>
              </div>
            </div>

            <div class="col-6">

            </div>
          </div>
          <div class="profile-section">
            <div class="row">
              <div class="col-lg-6 col-md-6 ">
                <ul class="profile-menu no-list-style">
                  <li>
                    <a (click)="showPage('About')" [ngClass]="currentPage === 'About' ? 'primary font-medium-2 font-weight-600 active' : 'primary font-medium-2 font-weight-600'">Profile</a>
                  </li>
                  <li>
                    <a (click)="showPage('Friends')" [ngClass]="currentPage === 'Friends' ? 'primary font-medium-2 font-weight-600 active' : 'primary font-medium-2 font-weight-600'">Registries</a>
                  </li>

                </ul>
              </div>
              <div class="col-lg-6 col-md-6">
                <ul class="profile-menu no-list-style"></ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section id="about" *ngIf="currentPage === 'About'">

    <div class="row">
      <div class="col-sm-12">
        <profilesummary [ActorCode]='CurrentActorProfileController.ActorCode'
                        [CanEdit]='CanEditProfileSummary' [CanShow]='CanShowProfileSummary'
                        *ngIf="CurrentActorProfileController.ActorCode >0"></profilesummary>


      </div>

      <div class="col-sm-12">
        <personalinfo [ActorCode]='CurrentActorProfileController.ActorCode'
                      [CanEdit]='CanEditProfileInfo' [CanShow]='CanShowProfileInfo'
                      (personalInfoChange)="onpersonalInfoChange($event)" *ngIf="CurrentActorProfileController.ActorCode >0"></personalinfo>
      </div>
      <div class="col-sm-12">

        <contactinfo [ActorCode]='CurrentActorProfileController.ActorCode'
                     [CanEdit]='CanEditContactInfo' [CanShow]='CanShowContactInfo'
                     *ngIf="CurrentActorProfileController.ActorCode >0"></contactinfo>


      </div>
      <div class="col-sm-12">
        <employmentpreferences [ActorCode]='CurrentActorProfileController.ActorCode'
                               [CanEdit]='CanEditJobPreferences' [CanShow]='CanShowJobPreferences'
                               *ngIf="CurrentActorProfileController.ActorCode >0"></employmentpreferences>

      </div>
      <div class="col-sm-12">

        <div class="row">
          <div class="col-sm-6">
            <legalinfo [ActorCode]='CurrentActorProfileController.ActorCode'
                       [CanEdit]='CanEditLegalinfo' [CanShow]='CanShowLegalinfo'
                       *ngIf="CurrentActorProfileController.ActorCode >0"></legalinfo>
          </div>
          <div class="col-sm-6">
            <educationinfo [ActorCode]='CurrentActorProfileController.ActorCode'
                           [CanEdit]='CanEditEducation' [CanShow]='CanShowEducation'
                           *ngIf="CurrentActorProfileController.ActorCode >0"></educationinfo>
          </div>
        </div>
      </div>

      <div class="col-sm-12">

        <div class="row">
          <div class="col-sm-6">
            <employeehistoryinfo [ActorCode]='CurrentActorProfileController.ActorCode'
                                 [CanEdit]='CanEditEmploymentHistory' [CanShow]='CanShowEmploymentHistory'
                                 *ngIf="CurrentActorProfileController.ActorCode >0"></employeehistoryinfo>
          </div>
          <div class="col-sm-6">
            <professionalreference [ActorCode]='CurrentActorProfileController.ActorCode'
                                   [CanEdit]='CanEditReferences' [CanShow]='CanShowReferences'
                                   *ngIf="CurrentActorProfileController.ActorCode >0"></professionalreference>
          </div>
        </div>
      </div>

      <div class="col-sm-12">

        <div class="row">
          <div class="col-sm-6">
            <identitiesinfo [ActorCode]='CurrentActorProfileController.ActorCode'
                            [CanEdit]='CanEditIdentities' [CanShow]='CanShowIdentities'
                            *ngIf="CurrentActorProfileController.ActorCode >0"></identitiesinfo>
          </div>
          <div class="col-sm-6">
            <certificationsinfo [ActorCode]='CurrentActorProfileController.ActorCode'
                                [CanEdit]='CanEditCertifications' [CanShow]='CanShowCertifications'
                                *ngIf="CurrentActorProfileController.ActorCode >0"></certificationsinfo>
          </div>
        </div>
      </div>

      <div class="col-sm-12">

        <medicalfitnessinfo [ActorCode]='CurrentActorProfileController.ActorCode'
                            [CanEdit]='CanEditMedicalFitness' [CanShow]='CanShowMedicalFitness'
                            *ngIf="CurrentActorProfileController.ActorCode >0"></medicalfitnessinfo>


      </div>

    </div>
  </section>
  <section id="timeline" *ngIf="currentPage === 'TimeLine'">
    <div class="col-sm-12">
      <div class="card">
        <div class="card-header">

        </div>
        <div class="card-body">
          <employmentpreferences [ActorCode]='CurrentActorProfileController.ActorCode' *ngIf="CurrentActorProfileController.ActorCode >0"></employmentpreferences>

        </div>
      </div>

    </div>
  </section>
  <section id="timeline" *ngIf="currentPage === 'Friends'">
    <div class="col-sm-12">
      <div class="card">
        <div class="card-header">

        </div>
        <div class="card-body">
          <registryview [NurseActorCode]='CurrentActorProfileController.ActorCode'></registryview>

        </div>
      </div>

    </div>
  </section>
</div>-->
